// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__27Pw0","header":"MessagesList_header__1UnCB","chat":"MessagesList_chat__2yq7V"};